import palette from 'constants/palette'
import type { StyleObject } from 'styletron-react'

// baseui's own `kind="minimal"` style generator changes TEXT COLOR on
// hover (no underline) — design wants the opposite: same belize/bold text,
// underline only (VISUAL-SPEC.md §2 "Mark as resolved": "hover →
// text-decoration:underline (no color change)").
//
// Why every state has to be spelled out here. @thanx/uikit's `Button`
// builds its own `overrides.BaseButton.style` from `kind` and then spreads
// the CONSUMER's overrides after it (`Button.js`: `...(overrides || {})`) —
// a shallow merge at the slot level, so passing `BaseButton` REPLACES
// uikit's entirely rather than merging with it. uikit also never forwards
// `kind` to baseui, so baseui's own `BaseButton` is always styled as its
// default `$kind = primary`, whose base style carries
// `:hover { backgroundColor: buttonPrimaryHover }` (#002E4C, near-black).
// uikit's replaced style was the only thing neutralising that, so any state
// this helper leaves undeclared falls through to baseui's PRIMARY treatment
// — not to `kind="minimal"`. Omitting the `:hover` background is what put a
// near-black wash behind LookbackBackHeader's label.
type BaseButtonStyleProps = { $isFocusVisible: boolean }
const FOCUS_RING_SHADOW = `0 0 0 2px ${palette.belizeHole}`

export function textLinkButtonOverrides(extra: StyleObject = {}) {
  return {
    BaseButton: {
      style: ({ $isFocusVisible }: BaseButtonStyleProps) => ({
        // Longhand padding/border (not the `padding`/`border` shorthands) —
        // styletron warns "Styles {padding:0} and {paddingTop:14px} may
        // result in unexpected behavior" when a shorthand here fights a
        // longhand baseui's own generator sets for the same box side.
        paddingTop: '0px',
        paddingRight: '0px',
        paddingBottom: '0px',
        paddingLeft: '0px',
        backgroundColor: 'transparent',
        borderTopWidth: '0px',
        borderRightWidth: '0px',
        borderBottomWidth: '0px',
        borderLeftWidth: '0px',
        borderTopStyle: 'none' as const,
        borderRightStyle: 'none' as const,
        borderBottomStyle: 'none' as const,
        borderLeftStyle: 'none' as const,
        color: palette.belizeHole,
        fontSize: '13.5px',
        fontWeight: 800,
        boxShadow: $isFocusVisible ? FOCUS_RING_SHADOW : 'none',
        ':hover': {
          backgroundColor: 'transparent',
          textDecoration: 'underline',
        },
        ':disabled': {
          backgroundColor: 'transparent',
          color: palette.grey40,
        },
        ...extra,
      }),
    },
  }
}
